export const markdownHTTPHeaders = {
  headers: {'Content-Type': 'text/markdown; charset=UTF-8'}
}

export async function getUserManual(userManualPath: string): Promise<string> {
  const response = await fetch(userManualPath, markdownHTTPHeaders)
  return response.text()
}
